export default __webpack_public_path__ + "assets/images/others/8103eed213d44d8b3e959f9fed163ea4.gif";